import LoadingEllipsis from 'components/Loading/LoadindEllipsis'
import { StatusChamadaEnum } from 'models/atendimento/types'
import React from 'react'
import { AiOutlinePhone } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import { Modal, ModalHeader, ModalBody, Row, Col } from 'reactstrap'
import { ApplicationState } from 'store'
import { KANBAN } from 'store/modules/kanban/types'
import { SimpleTitleCard } from 'styles/global'

interface ModalDiscagemProps {
  isOpen: boolean
  onToggle: () => void
}

const statusLabel: Record<StatusChamadaEnum, string> = {
  [StatusChamadaEnum.naoIniciado]: 'Discando',
  [StatusChamadaEnum.discando]: 'Discando',
  [StatusChamadaEnum.atendida]: 'Em chamada',
  [StatusChamadaEnum.finalizada]: 'Desligado',
  [StatusChamadaEnum.erro]: 'Desligado'
}

const ModalDiscagem = ({ isOpen, onToggle }: ModalDiscagemProps) => {
  const { discagem } = useSelector<ApplicationState, KANBAN>(
    (state) => state.kanban
  )

  const label = statusLabel[discagem.statusChamada] ?? 'Discando'
  const isEncerrado =
    discagem.statusChamada === StatusChamadaEnum.finalizada ||
    discagem.statusChamada === StatusChamadaEnum.erro

  return (
    <Modal size="md" backdrop="static" isOpen={isOpen} toggle={onToggle}>
      <ModalHeader toggle={onToggle}>
        <SimpleTitleCard>
          <AiOutlinePhone className="icon" />
          Discagem
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody className="d-flex flex-column row-gap-15">
        {discagem.numeroDiscado && (
          <Row>
            <Col>
              <span className="fw-bold">{discagem.numeroDiscado}</span>
            </Col>
            <Col>
              {isEncerrado ? (
                <span>{label}</span>
              ) : (
                <LoadingEllipsis>
                  <span className="ellipsis">{label}</span>
                </LoadingEllipsis>
              )}
            </Col>
          </Row>
        )}
      </ModalBody>
    </Modal>
  )
}

export default ModalDiscagem
